/* eslint-disable
    func-names,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS201: Simplify complex destructure assignments
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const _ = require('lodash');

const deps = ['$scope', 'DocumentCollection', 'Document'];

const DmsTableCtrl = function ($scope, DocumentCollection, DocumentModel) {
  const init = (...args) => {
    const [id, documentType] = Array.from(args[0]);
    this.documents = new DocumentCollection(id);
    this.selectedDocuments = new DocumentCollection({
      $id: `${this.documents.$id}-Selected`,
      $lastUpdated: 1,
      documentType,
    });
    this.selectedDocuments.$useCachedModels = true;
    return this.selectedDocuments.$empty();
  };

  $scope.$watch('[vm.documentCollectionId, vm.documentType]', init.bind(this));

  this.onCheck = (checked, id) => {
    if (checked) {
      const selectedDocument = new DocumentModel(id);
      return this.selectedDocuments.$add(selectedDocument);
    }
    return this.selectedDocuments.$removeById(id);
  };

  this.isChecked = document => !_.isUndefined(this.selectedDocuments.$findById(document.id));

  this.selectAll = checked => {
    if (checked) {
      return this.selectedDocuments.$set(this.documents.$data());
    }
    return this.selectedDocuments.$empty();
  };

  init([this.documentCollectionId, this.documentType]);
};

DmsTableCtrl.$inject = deps;

module.exports = DmsTableCtrl;
